import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServicePackChecklistEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";

import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import lang from 'dojo/_base/lang';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import ServiceServicePackChecklistEditor from './ServiceServicePackChecklist/ServiceServicePackChecklistEditor';

class ServicePackChecklistEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    tableContainer: HTMLElement;

    inputRoomSection: HTMLDivElement;
    evRoomHintBox: MdsLax<InstanceType<typeof HintBox>>;

    serviceServicePackChecklistExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    serviceServicePackChecklistStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.ServiceServicePackChecklist>>>;
    serviceServicePackChecklistTable: MdsLax<InstanceType<typeof StaticTable>>;

    private sedFilterAttributes: any = {

    };
    
    tableRowLayout: StaticTable.RowConfig = {
        attributes: ["ref_service_checklist.description", "ev_service_text_booking"],
        colNamesInternal: ["ref_service_checklist.description", "ev_service_text_booking"],
        headings: [(this as any).translate("General_Label_Description"), (this as any).translate("General_Label_BookingNote")],
        colspans: [1, 1],
    }

    tableLayout: StaticTable.Layout = {
        label: "serviceServicePackChecklistTable",
        name: "serviceServicePackChecklistTable",
        rows: [(this as any).tableRowLayout],
    }


    isValid(): boolean {
        //Need to implement
        return true;
    }

    private updatePositionsTable() {

    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ServicePackChecklist;
    }

    private _onClick_OpenEvServicesSED(evt) {
        /*this.loadSelectEntityDialog(evt,
            "selectEvServices",
            lang.hitch(this, this._onCallback_Dlg)
        );*/
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        var servicesServicePackChecklist = this.getAttributeValue("EL_service_service_pack_checklist_service_pack_checklist");
        servicesServicePackChecklist.sort((a, b) => {
            return a.order - b.order;
        })
        this.serviceServicePackChecklistStore.setup(servicesServicePackChecklist);
        this.serviceServicePackChecklistTable.setupFromStore(this.serviceServicePackChecklistStore);

        this.serviceServicePackChecklistExpander.setMarking(servicesServicePackChecklist.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _setupTable(): void {
        this.serviceServicePackChecklistTable = new StaticTable();
        this.serviceServicePackChecklistTable.addLayout(this.tableLayout);
        this.serviceServicePackChecklistTable.setupFromStore(this.serviceServicePackChecklistStore);
        this.serviceServicePackChecklistTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.serviceServicePackChecklistTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditTableRowButton));
        this.serviceServicePackChecklistTable.addDefaultRowActionButton("delete");
        this.serviceServicePackChecklistTable.setCyAttribute("serviceServicePackChecklistTable");

        this.serviceServicePackChecklistTable.placeAt(this.serviceServicePackChecklistExpander);
    }

    private _onClickTableRow(row: StaticTable.StaticTableRow<MainCatalogTypes.ServiceServicePackChecklist>): void {
        let entity = row.rowGroup.entity;

        this._openEditor(entity);
    }

    private _onClickEditTableRowButton(rowGroup: StaticTable.StaticTableRowGroup<MainCatalogTypes.ServiceServicePackChecklist>): void {
        let entity = rowGroup.entity;

        this._openEditor(entity);
    }

    private _onClickAdd(evt): void {
        this.loadSelectEntityDialog(evt,
            "selectServiceChecklist",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.sedFilterAttributes
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.Entity_description>>) {
        if (!items || !items.length) return;
        if (mode == "selectServiceChecklist") {
            for (let item of items) {

                let entity: Partial<VAM2types.Entity_description> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }
                else {

                }

                this.addNewEntry(entity as any);
            }
        }
    }

    
    private addNewEntry(value: MainCatalogTypes.ServiceServicePackChecklist) {
        if (value != null) {

            let fakeServiceServicePackChecklist: Partial<MainCatalogTypes.ServiceServicePackChecklist> = {
                ref_service_checklist: value
            }

            if (this.serviceServicePackChecklistStore.isEntityExisting(fakeServiceServicePackChecklist as any, "ref_service_checklist.ID", true)) {
                this.showToast({
                    title: this.translate(`ServiceChecklist_Toast_ExistInList`),
                    message: `**${value.$Displayname}**  ${this.translate(`ServiceChecklist_Toast_ExistInList_details`)}`,
                    messageIcon: "fas fa-info-circle",
                    iconClass: "fas fa-info-circle"
                });
            }
            else {
                this.serviceServicePackChecklistStore.addEntry(fakeServiceServicePackChecklist as any, "new");
            }
        }
    }

    private _openEditor(entity: MainCatalogTypes.ServiceServicePackChecklist): void {
        let serviceServicePackChecklistEditor = new ServiceServicePackChecklistEditor();
        serviceServicePackChecklistEditor.setup(entity);

        serviceServicePackChecklistEditor.on("confirmed", lang.hitch(this, this._onEditorConfirmed))
    }

    private _onEditorConfirmed(entity: MainCatalogTypes.ServiceServicePackChecklist): void {
        this.serviceServicePackChecklistStore.changeEntry(entity, true);
    }

    private _onChangeStore(): void {
        var serviceServicePackChecklistDiffData = this.serviceServicePackChecklistStore.getDiffData();
        this.setAttributeValue("serviceServicePackChecklistDiffData", serviceServicePackChecklistDiffData);

        this.serviceServicePackChecklistExpander.setMarking(this.serviceServicePackChecklistStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChangeAddEvRoom(): void {

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.serviceServicePackChecklistStore = new EntityStore();
        this.serviceServicePackChecklistStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();

        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServicePackChecklistEditor);